'use client';
import type { LucideIconName } from '../assets/icons';
import { LUCIDE_ICONS } from '../assets/icons';
import { Icon } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import { forwardRef } from 'react';

/**
 * This component is a client component that renders a Lucide icon.
 * It is used to render a Lucide icon in the UI.
 * If you get an error `Only plain objects can be passed to Client Components from Server Components.`,
 * you can use this component instead of the `Icon` component.
 * @param param0
 * @returns
 */
export const LucideIcon = forwardRef<SVGSVGElement, { name: LucideIconName } & ComponentProps<typeof Icon>>(
  ({ name, ...props }, ref) => {
    const LucideIconComponent = LUCIDE_ICONS[name] as React.ElementType;

    if (!LucideIconComponent) {
      console.error(`Icon "${name}" not found in Icons, please add icon in src/assets/icons.ts`);
      return null;
    }

    return (
      <Icon asChild ref={ref} {...props}>
        <LucideIconComponent />
      </Icon>
    );
  },
);
